import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  DialogActions,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { Alert, Skeleton } from "@material-ui/lab";
import { PaymentService } from "../e_bkash/model/e_service";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {routePaths} from '../../../../components/config/route-paths'
import { history } from "../../../../helpers";

const useStyle= makeStyles((theme)=>({
    root: {
        backgroundColor: theme.palette.eSecondary.base,
        color: theme.palette.eWhite.base,
        borderRadius: "20px",
        "&:hover": {
          backgroundColor: theme.palette.eSecondary.base
        },
        '&.Mui-disabled': {
          borderRadius: "20px",
        }
      },
  payNowButton:{
    align : "center",
    justifyContent : "center",
    justify : "center"
  },
  disabledButton: {
    borderRadius: "20px",
    backgroundColor: theme.palette.eSecondary.base,
    color: theme.palette.eWhite.base,
  },
})  
)


export default function BkashPayment({
  buttonProps,
  checked,
  payBalance
}) {
  
  const [err, seterr] = useState(false);
  const [paymentConfirmationWidget,setPaymentConfirmationWidget]=useState(true)
  const [openDialog, setOpen] = useState(false);
  let labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_MAKE_PAYMENT
  );
  
  let widgets = useSelector((state) => state?.parametersWidgets?.WidgetLookUp.E_PAYMENT_CONFIRMATION);

  useEffect(() => {
    widgets &&
      widgets.map((item) => {
        if (item.widgetCode === "E_PAYMENT_CONFIRMATION") {
          setPaymentConfirmationWidget(item.widgetDefaultValue === "true" ? true : false);
        }
      });
  }, [widgets]);

  const debounce = (fn, delay) => {
    let timeoutId;
    return function(...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const oneTimePaymentsPage=()=>{
    history.push(routePaths.ONE_TIME_PAYMENTS)
  }


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const {t:label, ready:labelready} = useTranslation("label-E_NESCO_PAYMENT")

  const customerId = localStorage.getItem("accountId")
  
  const [bkashData,setBkashData] = useState()
  const btnCall = () => {
    handleClickOpen();
    let amountPay = parseFloat(payBalance)
    PaymentService.prepayment(amountPay,customerId)
    .then((res) => {
        if(res?.data?.prePaymentProcessing){
            seterr(false);
            setBkashData(res?.data?.prePaymentProcessing)
            localStorage.setItem("transactionDate",res?.data?.prePaymentProcessing?.paymentCreateTime)
            window.location.replace(res?.data?.prePaymentProcessing?.bkashURL)
            handleClose();  
        }
    })
    .catch((err) => {
            handleClose();
            seterr(true);
          });
  };

const classes = useStyle()
let payNowLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_AUTH_PAYMENT
  );
  return (
  <>

      <Button
        type="submit"
        variant="contained"
        onClick={oneTimePaymentsPage}
        disabled={!checked}
        className={classes.root}
        classes={{ disabled: classes.disabledButton }}
        { ...buttonProps }
      >
       {labelready ? label("E_RECHARGE_NOW"):<Skeleton/>}
      </Button>
      
      {err ? <Alert severity="error"  className={classes.errorStyle}>{label("E_API_ERROR")}</Alert>:<div className={classes.paddingError}/>}
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={openDialog}
      >
        <DialogTitle id="simple-dialog-title">
          <Typography color="primary" variant="h5">
            <b>{labels?.E_LOADING_DIALOG_TITLE}</b>
          </Typography>
        </DialogTitle>
        <DialogContent align="center">
          <div className="margin-top-20">
            <CircularProgress color="primary" size={60} />
          </div>
        </DialogContent>
        <DialogActions>
          <Typography className="padding-10">
            {label("E_PAYMENT_LOADING")}
          </Typography>{" "}
        </DialogActions>
      </Dialog></>
    
  );
}
